import { TreeItem, ItemType, TreeItemCheckedType } from './item';
import { GroupItem } from './group-item';
import { DossierTree } from './tree';
import { filter, sortBy, each, remove } from 'lodash';
import { sortByNumberReverse } from '../../utils';

const sortByGroupOrderFn = sortByNumberReverse('group.order');

export class SimpleItemWithGroups extends TreeItem {

  target: any
  private _groups: GroupItem[] = [];

  constructor(target: any, parent: TreeItem, tree: DossierTree) {
    super(parent, tree);
    this.target = target;

    // Process groups
    let gs = filter(this.tree.dossier.link_groups, (g) => g.link_name === this.target.id);

    gs = sortBy(gs, (g) => g.order);

    if (gs.length > 0) {

      // Create group items
      each(gs, g => {
        let item = new GroupItem(g, this, tree);

        this._groups.push(item);
      });

      // Initial sort of groups
      this._groups.sort(this.sortByGroupOrder);

      // Select the last group
      this.selectedGroup = this._groups[0];
    }
  }

  get groups(): GroupItem[] {
    return this._groups;
  }

  get type(): ItemType {
    return 'SIMPLE_WITH_GROUPS';
  }

  get label(): string {
    let label = this.target.text;

    if (this.selectedGroup) {
      label += ' (' + this.selectedGroup.children.length + ')';
    }

    return label;
  }

  get children(): TreeItem[] {
    return this.selectedGroup ? this.selectedGroup.children : this.groups;
  }

  set children(items: TreeItem[]) {
    // Ignore
  }

  private sortByGroupOrder(a: GroupItem, b: GroupItem): number {
    return sortByGroupOrderFn(a, b);
  }

  addGroup(group: GroupItem) {
    this._groups.push(group);

    this._groups.sort(this.sortByGroupOrder);
  }

  removeGroup(group: GroupItem) {
    remove(this._groups, child => child === group);

    this._groups.sort(this.sortByGroupOrder);
  }

  reorderGroups() {
    this._groups.sort(this.sortByGroupOrder);
  }

  expand() {
    this.selectedGroup = null;
    this.closed = false;
  }

  toggleExpand() {
    if (this.selectedGroup) {
      this.expand();
    }
    else {
      this.selectedGroup = this._groups[0];
    }
  }

  get nextOrder(): number {
    if(this._groups.length === 0) {
      return 0;
    }
    else {
      return this._groups[0].group.order + 1;
    }
  }

  get checked(): TreeItemCheckedType {
    if(this.selectedGroup) {
      return this.selectedGroup.checked;
    }
    else {
      return 'DISABLED';
    }
  }

  set checked(value: TreeItemCheckedType) {
    if(this.selectedGroup) {
      this.selectedGroup.checked = value;
    }
  }
}